<template>
  <div>
    <div class="web-body">
      <div class="about">
        <div class="row clearfix product-box">
          <h1>隐私政策</h1>
          <br>
          更新日期：2023年11月10日
          <br>
          生效日期：2023年11月10日
          <br>
          <br>
          <b>【前言】</b>
          <br>
          欢迎您选择由广州卓讯互动信息技术有限公司及其关联方（简称“我们”）提供的游戏服务。我们深知个人信息对您的重要性，依据《中华人民共和国个人信息保护法》《中华人民共和国网络安全法》《信息安全技术个人信息安全规范》以及其他相关法律法规和技术规范，我们拟定了本《隐私政策》（以下简称“本政策”）的相关内容。如您对本政策内容有任何异议或疑问，您可通过本政策第十条“联系方式”与我们取得联系。
          <br>
          <br>
          <b>【特别提示】</b>
          <br>
          1、本政策适用于我们提供的游戏服务（包括现在正在提供和将来可能向用户提供的游戏服务和其他网络服务）。
          <br>
          2、未满十四周岁的用户，同时适用本政策以及《儿童个人信息保护声明及监护人须知》。如特定条款与本政策条款存在同类条款的不一致约定，则在特定条款约束范围内应以特定条款为准。如我们提供的某一单项服务不适用本政策的，该服务中会以适当方式明示排除适用本政策。
          <br>
          3、为了向您提供更全面的游戏服务，游戏中嵌入了第三方SDK或类似应用程序，因此第三方SDK或类似应用程序可能也会收集您的个人信息。我们将要求第三方对您的信息采取保护措施并且严格遵守相关法律法规与监管要求。
          <br>
          4、本政策约定了在不同场景下我们处理您的信息的方式，但只有当您开启相关功能或使用相关服务时，为实现相关功能、服务，我们才会处理您的信息；如您不开启相关功能或使用相关服务，我们不会处理您对应的个人信息。除本政策外，在特定产品中，我们还会通过即时告知如弹窗、页面提示等方式，向您说明该产品特定的信息收集目的、范围及使用方式，这些即时告知内容构成本隐私政策的一部分，并与本政策具有同等效力，请您特别留意。
          <br>
          5、您退出游戏后，需要在后台网络完成的部分服务，如更新游戏、接收消息等功能，在您选择退出游戏后，仍可能在一定条件下自启动或关联启动。
          <br>
          6、在使用我们提供的服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后再开始使用。如您不同意本政策内容，将可能导致游戏服务无法正常运行，或无法达到我们拟达到的服务效果。如您在弹窗及页面中勾选“同意”即表示您充分理解并同意本政策的全部内容。
          <br>
          <br>
          <b>本政策将帮助您了解以下内容：</b>
          <br>
          一、我们如何收集和使用您的个人信息
          <br>
          二、我们如何使用COOKIES或同类技术
          <br>
          三、我们可能共享、转移或公开您的个人信息
          <br>
          四、我们如何存储和保护您的个人信息
          <br>
          五、如何行使您的个人信息相关权利
          <br>
          六、未成年人保护
          <br>
          七、修订和通知
          <br>
          八、如何联系我们
          <br>
          <br>
          <h2>一、我们收集的信息</h2>
          <table border="1" cellpadding="0" cellspacing="0">
            <tr>
              <th width="160">信息类型</th>
              <th width="400">信息内容</th>
              <th width="400">收集用途</th>
            </tr>
            <tr>
              <td>个人信息</td>
              <td>用户名、密码、手机号码、电子邮箱、姓名、身份证号码</td>
              <td>保障个人账号安全及满足相关法律法规的网络实名制要求</td>
            </tr>
            <tr>
              <td>设备信息</td>
              <td>IMEI、MAC、Android ID、OAID、IDFA、OpenUDID、GUID、SIM卡IMSI、ICCID、IP地址、设备型号、操作系统、网络类型</td>
              <td>分析网站、APP等线上平台的访问效果及统计数据，以便持续优化您的使用体验</td>
            </tr>
            <tr>
              <td>软件信息</td>
              <td>安装应用列表、进程、应用崩溃记录</td>
              <td>保障软件和服务的安全</td>
            </tr>
            <tr>
              <td>日志信息</td>
              <td>服务的请求时间、请求协议类型、客户端IP地址、请求成功的状态、请求的资源路径、客户端设备信息（如设备类型、操作系统类型及版本）</td>
              <td>履行法定义务、保障产品或服务可靠及安全稳定运行及优化产品和服务等</td>
            </tr>
            <tr>
              <td>位置信息</td>
              <td>基站信息、精确地理位置</td>
              <td>提供游戏定位相关玩法服务（例：区域排行榜、同城玩家等）</td>
            </tr>
          </table>
          <br>
          在您本游戏及服务的过程中，我们将根据合法、正当、必要的原则，我们会按照如下方式收集您在使用服务时主动提供的或因为使用服务而产生的信息，用以保障产品的正常运行和功能、改善产品和服务以及保障用户使用安全。
          <br>
          <b>（一）注册、登录、认证</b>
          <br>
          1、如果您使用第三方账号登录并使用本游戏，您将授权我们获取您在第三方平台<b>注册的公开信息（头像、昵称以及您授权的其他信息）</b>，用以和本游戏绑定并保存您的登录信息，使您可以登录并使用本游戏和相关服务。
          <br>
          2、根据具体使用情况，您可能需要提供您的<b>真实身份信息（真实姓名、身份证号码、电话号码）</b>以完成实名验证。这些信息属于个人敏感信息，您可以拒绝提供，但您将可能无法获得相关服务，但不影响其他功能与服务的正常使用。
          <br>
          3、如果您使用第三方账号登录并使用本游戏，您将授权我们使用您的<b>好友关系</b>、您在游戏中的相关<b>操作信息、游戏信息等信息</b>（具体包括但不限于您的登录状态、对战信息/状态、成就信息等）以及您授权的其他信息，用于向您本人或其他用户或好友展示。我们可能会视游戏产品具体情况为您提供相关权限，以便您可以对是否展示前述相关信息进行相应设置。
          <br>
          <b>（二）程序正常、安全运行</b>
          <br>
          1、为了保障软件与服务的安全、正常运行，我们会收集您的<b>硬件型号、操作系统版本号、国际移动设备识别码、唯一设备标识符、网络设备硬件地址、IP地址、WLAN接入点、MAC地址、应用ID、蓝牙、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志等信息</b>。如您使用小米、魅族、华为等品牌手机，游戏接入的上述手机厂商PushSDK需要收集手机唯一标识信息（例如IMEI），并可能会收集您的设备屏幕尺寸等参数。
          <br>
          2、为了使您能够在客户端查看您的游戏历史记录，同时用于判断账户安全、进行身份验证、检测及防范安全事件、游戏运营统计分析、客服投诉处理及其他游戏安全分析，并为提升您的游戏体验，我们会收集您的<b>账户信息、设备信息、服务日志信息</b>以及我们关联公司、合作方在获得您授权或依法可以共享的信息、您使用应用程序和服务的信息，例如<b>登录日志、物品日志、游戏对局信息、交友记录、应用程序和服务产生的连接和服务相关的数据信息、网络测试、服务质量、日期、时间和地理位置等</b>。
          <br>
          3、为了预防恶意程序及安全、稳定运营，我们可能会收集<b>安装的应用信息或运行中的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源</b>。
          <br>
          4、当您使用的游戏产品具有消费功能，我们会收集您的<b>充值记录、消费记录</b>等信息，以便您查询您的交易记录并保护您的虚拟物品安全。
          <br>
          5、我们可能会收集并保存您在游戏中通过<b>文字、图片、语音、视频</b>及其他方式与其他玩家进行的互动，用于过滤色情、暴力、恶意广告等不当内容。
          <br>
          6、根据游戏和服务内容，在您授权同意后，游戏会访问您的<b>麦克风、摄像头</b>，为您提供语音聊天、直播互动等功能。
          <br>
          7、您使用与位置有关的服务时，我们可能会记录您设备所在的<b>位置信息</b>，以便为您提供与附近的游戏玩家互动。地理位置信息属于敏感信息，拒绝提供该信息只会导致您无法实现与附近的游戏玩家互动，但不影响您正常使用本游戏的其他功能，您也可以随时取消您的地理位置信息授权。
          <br>
          8、在触发有游戏奖励时，可能会查询您的<b>奖励清单明细</b>，用于进行奖励发放核对、补发等功能。
          <br>
          <b>（三）申请授权的权限、目的及所涉个人信息</b>
          <br>
          为更好的为您提供服务，保障程序正常、安全运行，我们将向您申请以下权限。以下权限的申请方式包括但不限于：弹窗提示、界面提示等。同一权限在不同终端设备上的获取方式可能有所不同，具体以您使用的终端设备实际采用方式为准。
          <br>
          由于设备差异，导致获取部分权限在不同设备上会以不同的方式出现；例如读取IMEI号可能会以“要允许XX软件拨打电话和管理通话吗？”的形式出现；信息存储可能会以“要允许XX软件访问您设备商的照片、媒体内容和文件吗？”的形式出现，但我们保证仅获取用户的IMEI、信息存储、定位等权限不会收集您的隐私，仅用以保障产品的正常运行和功能、改善产品和服务以及保障用户使用安全。
          <br>
          向您申请的部分权限由我们的合作厂商SDK获取，关于合作厂商SDK请参考第四部分。
          <br>
          <table border="1" cellpadding="0" cellspacing="0">
            <tr>
              <th width="320">向您申请的权限</th>
              <th width="320">申请权限的目的</th>
              <th width="320">所涉个人信息</th>
            </tr>
            <tr>
              <td>读取电话状态</td>
              <td>保障程序安全、稳定运行</td>
              <td>设备信息</td>
            </tr>
            <tr>
              <td>写入外置存储器（SD卡）</td>
              <td>存储APP信息</td>
              <td>外置存储器信息</td>
            </tr>
            <tr>
              <td>读取外置存储器（SD卡）</td>
              <td>读取APP信息</td>
              <td>外置存储器信息</td>
            </tr>
            <tr>
              <td>访问粗略的位置（基站、WIFI）</td>
              <td>提供更好的游戏体验</td>
              <td>位置信息</td>
            </tr>
            <tr>
              <td>访问精确的位置</td>
              <td>提供更好的游戏体验</td>
              <td>位置信息</td>
            </tr>
            <tr>
              <td>支持后台访问位置</td>
              <td>若有（详见合作方SDK权限获取）</td>
              <td>第三方所需权限</td>
            </tr>
            <tr>
              <td>获取APP账户</td>
              <td>若有（详见合作方SDK权限获取）</td>
              <td>第三方所需权限</td>
            </tr>
          </table>
          <br>
          我们将会使用网络以执行用户游戏信息获取，参数调取下发，包括病毒库更新、垃圾缓存数据库、接受版本更新信息等。
          <br>
          1、我们将使用<b>读取、修改存储设备的内容权限</b>来查看存储在设备上文件并对文件执行操作，从而完成向用户显示有关信息，下载并安装APP以及下载查看相关文件的目的。
          <br>
          2、我们将<b>获取您的手机状态</b>，以让我们识别您的手机设备，从而将用户游戏中的重要数据和设备绑定，防止数据丢失。
          <br>
          3、我们将获取追踪<b>用户安装来源</b>的权限，用于判断用户从何渠道安装了本游戏。
          <br>
          4、我们可能会获取访问<b>粗略的位置（基站、wifi）</b>权限，用于部分游戏中用户排行榜，用户沟通交互用途。
          <br>
          <b>（四）根据相关法律法规及国家标准，我们可能会收集、使用您的相关个人信息且无需征求您的授权同意：</b>
          <br>
          1、与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公共知情等重大公共利益直接相关的；
          <br>
          2、与犯罪侦查、起诉、审判和判决执行等直接相关的；
          <br>
          3、出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；
          <br>
          4、所收集的个人信息是您自行向社会公众公开的；
          <br>
          5、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
          <br>
          6、根据您要求签订和履行合同所必需的；
          <br>
          7、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
          <br>
          8、为开展合法的新闻报道所必需的；
          <br>
          9、出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
          <br>
          10、法律法规规定的其他情形。
          <br>
          <br>
          <h2>二、收集信息的使用</h2>
          我们严格遵守法律法规的规定以及与用户的约定，按照本政策所述使用收集的信息，以向您提供更为优质的服务。
          <br>
          <b>（一）我们会按照如下规则使用收集的信息：</b>
          <br>
          1、我们会根据我们收集的信息向您提供各项功能与服务，包括基础游戏功能、玩家互动功能、消费功能等；
          <br>
          2、我们会根据您使用产品的频率和情况、故障信息、性能信息等分析我们产品的运行情况，以确保服务的安全性，并优化我们的产品，提高我们的服务质量。我们不会将我们存储在分析软件中的信息与您提供的个人身份信息相结合；
          <br>
          3、使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您；
          <br>
          4、为了让您获得更好的体验、改善我们的服务，我们可能将通过某一项服务所收集的信息，以汇集信息，用于我们的其他服务。例如，在您注册某一个产品账号时，为了避免重复注册，我们将对您注册的账号进行本公司内服务唯一性校验，以方便您在使用我们其他产品时可以直接进行登录；
          <br>
          5、软件认证或管理软件升级；
          <br>
          6、邀请您参与有关我们产品和服务的调查；
          <br>
          7、我们可能在必要时(例如因系统维护而暂停某一项服务时)向您发出与服务有关的公告。您可能无法取消和限制这些与服务有关且性质不属于推广的公告；
          <br>
          8、我们将在本政策所覆盖的用途内使用收集的信息。如我们使用您的个人信息超出了收集时所声称的目的、及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。
          <br>
          <b>（二）告知变动目的后征得同意的方式</b>
          <br>
          当本游戏新功能或服务与我们当前提供的功能或服务与原处理目的无直接或合理关联的时，我们收集、使用您的个人信息时，会再次进行告知，并征得您的同意。如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，并再次征得您的明示同意。
          <br>
          <b>（三）停止运营后的信息处理</b>
          <br>
          如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。
          <br>
          <br>
          <h2>三、对于共享、转让、公开披露个人信息的处理方式</h2>
          <b>（一）基本内容</b>
          <br>
          1、除本政策规定的情形外，我们不会主动共享、提供或转让您的个人信息至第三方，如存在其他共享、提供或转让您的个人信息或您需要我们将您的个人信息共享、提供或转让至第三方情形的，我们会直接或确认该第三方征得您对上述行为的明示同意。
          <br>
          2、除本政策另有规定，或遵循国家法律法规规定或者获得您的同意外，我们不会对外公开披露所收集的个人信息。如必须公开披露时，我们会采用符合行业内标准的安全保护措施，并我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。
          <br>
          3、我们不会转让您的个人信息给任何其他第三方，除非征得您的明确同意。
          <br>
          <b>（二）共享</b>
          <br>
          1、如向我们的关联方、第三方共享您的个人信息，需经过您的授权同意，除非共享的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。如果关联方、第三方使用信息的目的超越原授权同意范围，他们需要重新征得您的同意。
          <br>
          2、我们向关联方、第三方共享的数据将具有合法正当目的，且共享的数据以达成目的必要为限。
          <br>
          3、我们将审慎评估关联方、第三方数据使用共享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包(SDK)、应用程序接口(API)进行严格的安全监测，以保护数据安全。请您注意：第三方SDK会在您使用本游戏的情况下收集您的部分信息，拒绝提供可能会导致您无法登录本游戏或在使用本游戏过程中受到相应限制。通过本游戏为您提供服务的第三方SDK，会根据其自身隐私政策所述标准存储、使用、处理和保护您的个人信息，本隐私政策不能代替上述第三方的隐私政策。我们会审慎选择接入的第三方SDK并尽力要求第三方SDK为您的个人信息安全提供足够的保护，<b>同时强烈建议您在使用上述第三方SDK服务前先行阅读其相关隐私政策</b>（具体接入第三方SDK目录表详见后文），请您审慎了解、确认其隐私保护情况，做出您认为适当的选择，并且您明确知晓，对于您的自由选择出现的任何后果由您本人自行承担，我们不对此承担任何责任。
          <br>
          4、当您在使用本游戏中由我们的关联方、第三方提供的功能，或者当软件服务提供商、智能设备提供商、系统服务提供商与我们联合为您提供服务时，我们会将去标识化后的个人信息与这些关联方、第三方共享，进行综合统计与分析。
          <br>
          5、我们可能会与委托我们进行推广和广告投放的合作伙伴共享信息，但<b>我们不会共享用于识别您个人身份的信息(姓名、身份证号)，仅会向这些合作伙伴提供不能识别您个人身份的去标识化或匿名化后的信息</b>，以在不识别您个人身份的前提下，帮助我们分析、衡量广告和相关服务的有效性并提升广告有效触达率。
          <br>
          6、为保障使用安全和分析使用情况，我们和关联公司或服务提供商可能会共享<b>必要的设备、账号及日志信息、产品使用情况(崩溃、闪退)</b>的统计性数据，这些数据难以与其他信息结合识别您的个人身份。
          <br>
          <b>（三）根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息且无需事先征得您的授权同意：</b>
          <br>
          1、与国家安全、国防安全直接相关的；
          <br>
          2、与公共安全、公共卫生、重大公共利益直接相关的；
          <br>
          3、与犯罪侦查、起诉、审判和判决执行等直接相关的；
          <br>
          4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          <br>
          5、个人信息主体自行向社会公众公开个人信息的；
          <br>
          6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
          <br>
          <br>
          <h2>四、合作厂商SDK、广告展示及、Cookies技术条款</h2>
          <b>（一）合作厂商SDK</b>
          <br>
          我们的产品中可能会包含合作厂商SDK或其他类似的应用程序，如您在我们平台上使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息（如嵌入代码、插件等形式）。
          <br>
          这些被嵌入的第三方服务，游戏在前台或后台都可能会收集您终端用户的个人信息（IMEI、IP 地址、AndroidID、oaid
          IDFA、OPENUDID、GUID、SIM卡IMSI、安装软件列表、位置、硬件设备序列号等信息），并传输给第三方（具体见下方第三方合作厂商）且该等第三方服务均由相对应的第三方负责运营。前述服务商收集和处理信息等行为遵守其自身的隐私条款，而不是适用于本政策。为保障您的合法权益，如您发现这等SDK或其他类似的应用程序存在风险时，建议您立即终止相关操作并及时与我们取得联系。
          <br>
          具体的第三方合作厂商及其隐私政策链接（收集信息内容请参考第三方隐私政策）：
          <br>

          <table border="1" cellpadding="0" cellspacing="0">
            <tr>
              <th width="160">第三方服务名称</th>
              <th width="160">合作厂商</th>
              <th width="320">收集的信息</th>
              <th width="160">收集用途</th>
              <th width="160">隐私政策链接</th>
            </tr>
            <tr>
              <td>Unity3D SDK</td>
              <td>Unity Software Inc.</td>
              <td>唯一设备标识符（IDFV、AndroidID）、IP地址、安装国家、地区、设备制造商和型号平台类型、操作系统、版本、语言、CPU信息、显卡信息、已安装游戏的应用程序或捆绑包标识（应用ID）</td>
              <td>游戏制作和改善游戏体验</td>
              <td>
                <a2><a href="https://unity.cn/legal/china-privacy-policy" target="self">https://unity.cn/legal/china-privacy-policy<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>腾讯浏览服务SDK</td>
              <td>深圳市腾讯计算机系统有限公司</td>
              <td>设备信息（设备型号、操作系统、CPU类型）、应用信息（宿主应用包名，版本号）、WiFi状态和参数、位置信息、附近的WiFi、CellID</td>
              <td>提供网页引擎服务</td>
              <td>
                <a2><a href="https://x5.tencent.com/tbs/guide/develop.html" target="self">https://x5.tencent.com/tbs/guide/develop.html<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>Chromium SDK</td>
              <td>Google Inc.</td>
              <td>
                唯一标识符（IDFV、AndroidID、IMEI）、浏览器类型和设置、设备类型和设置、操作系统、移动网络信息、应用版本号、IP地址、崩溃报告、系统活动、位置信息（GPS、IP地址）、SSID、BSSID
              </td>
              <td>提供浏览器开发服务</td>
              <td>
                <a2><a href="https://policies.google.com/privacy" target="self">https://policies.google.com/privacy<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>深圳唯变SDK</td>
              <td>深圳市唯变科技开发有限公司</td>
              <td>IP地址、IMEI、MEID、Android ID、Mac地址、OAID、IDFA、OpenUDID、GUID、SIM卡IMSI、位置、硬件设备序列号、运行中的进程</td>
              <td>满足游戏基础服务功能，信息推送</td>
              <td>
                <a2><a href="https://pro.77pin.net/pro/gamePrivate.html" target="self">https://pro.77pin.net/pro/gamePrivate.html<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>深圳动能无线传媒SDK</td>
              <td>深圳市动能无线传媒有限公司</td>
              <td>IP地址、IMEI、MEID、Android ID、Mac地址、OAID、IDFA、OpenUDID、GUID、SIM卡IMSI、位置、硬件设备序列号、运行中的进程</td>
              <td>满足游戏基础服务功能，信息推送</td>
              <td>
                <a2><a href="https://pro.77pin.net/pro/gamePrivate.html" target="self">https://pro.77pin.net/pro/gamePrivate.html<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>YSDK</td>
              <td>深圳市腾讯计算机系统有限公司</td>
              <td>开发者个人信息，终端用户设备信息（AndroidID、手机型号、IP地址、Wi-Fi参数、运营商信息、SSID、BSSID、OAID、设备SN</td>
              <td>提供移动游戏开发公共组件和服务库</td>
              <td>
                <a2><a href="https://wikinew.open.qq.com/#/iwiki/1314826296" target="self">https://wikinew.open.qq.com/#/iwiki/1314826296<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>岳鹰全景监控SDK</td>
              <td>广州市动景计算机科技有限公司</td>
              <td>客户端APP唯一标识、日志类型、SDK安装唯一标志、网关采集的请求出口IP、联网、查询联网状态、读取系统错误日志、系统错误等崩溃日志、手机设备信息（机型、内存等）、应用运行错误信息、APP应用唯一标志
              </td>
              <td>APP崩溃监控，改善用户体验</td>
              <td>
                <a2><a href="https://yueying-docs.effirst.com/privacy.html" target="self">https://yueying-docs.effirst.com/privacy.html<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>腾讯Bugly SDK</td>
              <td>深圳市腾讯计算机系统有限公司</td>
              <td>日志信息、设备ID、联网信息、系统名称、系统版本以及国家码</td>
              <td>应用异常监控，改善用户体验</td>
              <td>
                <a2><a href="https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf" target="self">https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>数字联盟可信ID SDK</td>
              <td>北京数字联盟网络科技有限公司</td>
              <td>设备制造商、设备型号、设备系统版本、应用版本、传感器、陀螺仪、OAID、AndroidID、IDFA、IDFV、UAID、设备网络状况信息、设备物理环境信息、应用信息、通信状态、信号强度、蓝牙信息
              </td>
              <td>应用安全风控</td>
              <td>
                <a2><a href="https://www.shuzilm.cn/privacy" target="self">https://www.shuzilm.cn/privacy<a/></a2>
              </td>
            </tr>
            <tr>
              <td>UC啄木鸟SDK</td>
              <td>优视科技（中国）有限公司</td>
              <td>操作数据、账户ID、IP地址</td>
              <td>线上质量监控以及异常分析</td>
              <td>
                <a2><a href="https://open-uc.uc.cn/agreement/secret" target="self">https://open-uc.uc.cn/agreement/secret<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>热云数据TrackingIO SDK</td>
              <td>北京热云科技有限公司</td>
              <td>IDFA、IDFV、Android
                ID、MAC地址、IMEI、MEID、OAID、时区、APP包名、APP版本、系统版本、监测事件发生时间、运营商信息、设备型号、设备系统信息、设备硬件信息、设备运行环境信息、设备制造厂商、网络连接类型、设备操作系统版本、设备传感器信息、IP地址、虚拟交易金额、CAID
              </td>
              <td>移动广告效果监测，游戏运营分析</td>
              <td>
                <a2><a href="https://www.trackingio.com/#/policy" target="self">https://www.trackingio.com/#/policy<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>友盟+SDK</td>
              <td>友盟同欣（北京）科技有限公司、北京锐讯灵通科技有限公司</td>
              <td>IMEI、MAC、AndroidID、OAID、IDFA、OpenUDID、GUID、SIM卡IMSI、ICCID、IP、位置信息、网络信息</td>
              <td>应用数据统计分析服务、信息推送</td>
              <td>
                <a2><a href="https://developer.umeng.com/docs/147377/detail/209997" target="self">https://developer.umeng.com/docs/147377/detail/209997<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>BMS基础服务SDK</td>
              <td>广州勇往科技有限公司</td>
              <td>设备信息：IMEI、OAID、Android ID、MAC地址；应用信息：AppName、Openid</td>
              <td>提供账号服务、支付功能</td>
              <td>
                <a2><a href="https://static.zuiqiangyingyu.net/web-page/1/ZoZftMOrRqT3rudD" target="self">https://static.zuiqiangyingyu.net/web-page/1/ZoZftMOrRqT3rudD<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>微信 OpenSDK</td>
              <td>深圳市腾讯计算机系统有限公司</td>
              <td>身份信息、账户信息和交易信息</td>
              <td>使用微信客户端的支付能力</td>
              <td>
                <a2><a href="https://pay.weixin.qq.com/index.php/public/apply_sign/protocol_v2" target="self"><a/></a2>
              </td>
            </tr>
            <tr>
              <td>App 支付宝客户端 SDK</td>
              <td>支付宝（中国）网络技术有限公司</td>
              <td>Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表</td>
              <td>集成支付宝提供的支付功能</td>
              <td>
                <a2><a href="https://opendocs.alipay.com/common/02kiq3?pathHash=4bdc34df" target="self">https://opendocs.alipay.com/common/02kiq3?pathHash=4bdc34df<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>快手广告监测SDK</td>
              <td>北京快手科技有限公司</td>
              <td>IMEI、MEID、IMSI、Android
                ID、IDFA、IDFV、UAID、OAID、ICCID、Openudid、GAID、MAC地址、SSID、BSSID、蓝牙、基站、IP地址、网络运营商、网络状态、类型、接入方式、网络质量数据、设备名称、设备型号、设备序列号、应用程序版本、操作系统、语言、分辨率；日志信息
              </td>
              <td>广告投放、监测归因，投放数据分析</td>
              <td>
                <a2><a href="https://www.kuaishou.com/about/policy?tab=privacy" target="self">https://www.kuaishou.com/about/policy?tab=privacy<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>巨量引擎转化SDK</td>
              <td>北京巨量引擎网络技术有限公司</td>
              <td>
                设备品牌、型号、操作系统、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、浏览器的类型和版本号、操作、使用、服务日志；AndroidID、OAID、IDFV、MAC地址、BSSID、IMEI、IMSI、ICCID、GAID、MEID、设备序列号；开发者应用名、应用包名、运行中的进程信息、版本号、应用前后台状态；广告交互数据；崩溃数据、性能数据；运营商信息、设备时区、sim卡信息
              </td>
              <td>广告投放、监测归因，投放数据分析</td>
              <td>
                <a2><a href="https://open.oceanengine.com/doc/index.html?key=ad&type=api&id=1708428054592516"
                       target="self">https://open.oceanengine.com/doc/index.html?key=ad&type=api&id=1708428054592516<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>广点通转化 SDK</td>
              <td>深圳市腾讯计算机系统有限公司</td>
              <td>手机型号、连接的 Wi-Fi、Android ID、OAID、meid、Imei；应用信息；广告数据；用户使用数据</td>
              <td>广告投放、监测归因，投放数据分析</td>
              <td>
                <a2><a href="https://imgcache.qq.com/qzone/biz/gdt/dmp/user-action/privacy_agreement.pdf" target="self">https://imgcache.qq.com/qzone/biz/gdt/dmp/user-action/privacy_agreement.pdf<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>抖音游戏SDK</td>
              <td>北京微播视界科技有限公司、北京深极智能科技有限公司</td>
              <td>账号信息、硬件型号、操作系统版本号、设备标识符（IMEI、AndroidID、OAID、IMSI、ICCID、MEID、硬件序列号、IDFV、IDFA）、MAC地址、IP
                地址；SSID，BSSID、蓝牙、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、设备传感器；安装的应用信息或正在运行的进程信息
              </td>
              <td>提供广告服务</td>
              <td>
                <a2><a
                    href="https://game.open.douyin.com/support/content/132860?graphId=537&mappingType=2&pageId=308&spaceId=182&timestamp=1699963491835"
                    target="self">https://game.open.douyin.com/support/content/132860?graphId=537&mappingType=2&pageId=308&spaceId=182&timestamp=1699963491835<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>华为联运应用SDK</td>
              <td>华为软件技术有限公司</td>
              <td>应用功能设置、应用使用记录、设备标识符、产品品牌、国家码、操作系统、商业公开发布的内容（应用基本信息）、设备硬件信息（设备类型）、帐号信息（华为帐号ID）</td>
              <td>提供的应用分发和联合运营的开放能力及服务</td>
              <td>
                <a2><a
                    href="https://developer.huawei.com/consumer/cn/doc/AppGallery-connect-Guides/appgallerykit-app-sdk-security-0000001714810945"
                    target="self">https://developer.huawei.com/consumer/cn/doc/AppGallery-connect-Guides/appgallerykit-app-sdk-security-0000001714810945<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>小米游戏联运SDK</td>
              <td>小米深圳小米信息技术有限公司</td>
              <td>设备型号/model、手机制造商、游戏服务app版本、手机所设置的国家或地区、AndroidSDK版本号、游戏ID</td>
              <td>提供登录游戏、支付订单、游戏内交流服务</td>
              <td>
                <a2><a href="https://dev.mi.com/distribute/doc/details?pId=1402" target="self">https://dev.mi.com/distribute/doc/details?pId=1402<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>OPPO合作游戏SDK</td>
              <td>广东欢太科技有限公司</td>
              <td>账号信息（手机号码、密码、注册短信内容、姓名、身份证号码），设备名称、设备型号、设备识别码（ouid、oaid、duid）、IP 地址、操作系统版本，软件的事件信息</td>
              <td>提供的应用分发和联合运营的开放能力及服务</td>
              <td>
                <a2><a
                    href="https://ie-activity-cn.heytapimage.com/ie-activity/staticActivity/kpmYVr/htmls/kpmYVr.html?bizType=ie&actId=10001811&c=0"
                    target="self">https://ie-activity-cn.heytapimage.com/ie-activity/staticActivity/kpmYVr/htmls/kpmYVr.html?bizType=ie&actId=10001811&c=0<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>vivo联运SDK</td>
              <td>广东天宸网络科技有限公司</td>
              <td>IMEI、vaid、oaid、账号信息（如账号昵称、头像、openid）、实名身份信息（姓名、身份证号），允许安装应用权限，读取应用安装列表权限</td>
              <td>提供支付安全，账号服务等功能</td>
              <td>
                <a2><a href="https://dev.vivo.com.cn/documentCenter/doc/712" target="self">https://dev.vivo.com.cn/documentCenter/doc/712<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>4399运营SDK</td>
              <td>四三九九网络股份有限公司</td>
              <td>设备型号、操作系统、Wifi状态，获取进程信息 (仅限于本应用)，运营商信息、手机号，QQ账号、微信账号、微博账号、ApplelD
                (仅ios设备)；4399账号昵称、头像、密码密保问题、QQ账号、邮箱账号、手机号，IP地址，用户姓名、身份证，设备型号、设备系统版本、屏幕分辨率、网络状
              </td>
              <td>提供4399账户登录、充值、更新、游戏内容展示等功能</td>
              <td>
                <a2><a href="https://ptlogin.4399.com/resource/protocol.html?type=2&aids=4,10" target="self">https://ptlogin.4399.com/resource/protocol.html?type=2&aids=4,10<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>魅族联运SDK</td>
              <td>珠海星纪魅族信息技术有限公司</td>
              <td>Flyme 账号信息与您所使用账号所产生的相关信息，设备品牌、OAID、操作系统信息、设备类型、国家码、MEI、Mac 地址、SN 码、OAID、Android ID</td>
              <td>提供联运游戏登录、实名认证、防沉迷、游戏内支付的服务</td>
              <td>
                <a2><a href="https://open.flyme.cn/docs?id=234" target="self">https://open.flyme.cn/docs?id=234<a/></a2>
              </td>
            </tr>
            <tr>
              <td>233联运SDK</td>
              <td>北京龙威互动科技有限公司</td>
              <td>网络身份识别信息（如密码）、真实身份信息（真实姓名、身份证信息、电话号码）、网络日志信息、使用软件及相关服务的频率、崩溃数据、总体安装、使用情况、性能数据等信息</td>
              <td>接入渠道账号系统</td>
              <td>
                <a2><a href="https://dev.233leyuan.com/#/doc/5001"
                       target="self">https://dev.233leyuan.com/#/doc/5001<a/></a2>
              </td>
            </tr>
            <tr>
              <td>穿山甲广告SDK</td>
              <td>北京巨量引擎网络技术有限公司</td>
              <td>
                设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息、CPU信息、可用存储空间大小、AndroidID、OAID、IDFV、SSID、BSSID、MAC地址、IMEI、IMSI、ICCID、GAID、MEID、设备序列号、IDFA；IP地址、运营商信息、WiFi状态、网络信号强度；应用包名、运行中的进程信息、版本号、应用前后台状态；传感器信息；广告信息；位置信息；崩溃数据、性能数据
              </td>
              <td>提供广告服务</td>
              <td>
                <a2><a href="https://www.csjplatform.com/privacy" target="self">https://www.csjplatform.com/privacy<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>优量汇SDK</td>
              <td>深圳市腾讯计算机系统有限公司</td>
              <td>
                粗略位置信息，设备制造商、品牌、设备型号、操作系统版本、屏幕分辨率、屏幕方向、屏幕DPI、IP地址、时区、网络类型、运营商、设备名称、系统启动时间、系统语言、磁盘空间，传感器信息，OAID、IMEI、Android_ID、IDFV、
                IDFA，宿主应用的包名、版本号、应用安装信息，产品交互数据、广告数据、崩溃数据、性能数据
              </td>
              <td>提供广告服务</td>
              <td>
                <a2><a href="https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983" target="self">https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>Mintegral SDK</td>
              <td>广州汇世信息科技有限公司、北京汇量山河信息科技有限公司、聚移国际有限公司</td>
              <td>IP地址，国家，时区和区域设置；IMEI、Android
                ID、OAID、IDFV、IDFA、谷歌广告ID、亚马逊ID；MAC地址、IMSI；设备生产商，设备型号，设备的操作系统信息，设备类型，设备屏幕信息，设备电池信息，设备音量及字体大小，是否为模拟器，设备网络信息，设备硬件信息，设备传感器信息，设备存储容量信息；应用包名，应用版本和特性；广告交互数据
              </td>
              <td>提供广告服务</td>
              <td>
                <a2><a href="https://www.mintegral.com/cn/privacy"
                       target="self">https://www.mintegral.com/cn/privacy<a/></a2>
              </td>
            </tr>
            <tr>
              <td>快手广告SDK</td>
              <td>北京快手科技有限公司</td>
              <td>IMEI、MEID、IMSI、Android
                ID、IDFA、IDFV、UAID、OAID、ICCID、Openudid、GAID、MAC地址、SSID、BSSID、蓝牙、基站、IP地址、网络运营商、网络状态、类型、接入方式、网络质量数据、设备名称、设备型号、设备序列号、应用程序版本、操作系统、语言、分辨率；日志信息
              </td>
              <td>提供广告服务</td>
              <td>
                <a2><a href="https://www.kuaishou.com/about/policy?tab=privacy" target="self">https://www.kuaishou.com/about/policy?tab=privacy<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>米盟广告SDK</td>
              <td>深圳小米信息技术有限公司</td>
              <td>IMEI、OAID、AAID、UDID、VAID、Android ID、MAC地址、IMSI、设备型号、操作系统、IP地址、屏幕宽高、屏幕密度、Android版本号、SDK版本、MIUI版本号、
                MIUI版本名称、系统语言、UserAgent、手机地区、国家编码 、国家名称；WiFi状态、移动运营商、网络类型、网络连接状态；应用包名、版本号、运行中App的进程列表；广告交互数据
              </td>
              <td>提供广告服务</td>
              <td>
                <a2><a href="https://dev.mi.com/console/doc/detail?pId=2630" target="self">https://dev.mi.com/console/doc/detail?pId=2630<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>鲸鸿动能SDK</td>
              <td>华为软件技术有限公司</td>
              <td>设备标识符（OAID、Android
                ID）、设备信息（设备型号、设备硬件信息、操作系统、系统设置、设备使用信息）、应用基本信息、应用设置信息、应用使用信息、传感器信息（陀螺仪、加速度计、旋转矢量传感器、磁力计、气压计）、网络信息、运营商信息、IP地址、WiFi信息（WiFi状态、WiFi
                参数与WiFi列表）、广告互动信息
              </td>
              <td>提供广告服务</td>
              <td>
                <a2><a
                    href="https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/whale-hong-kinetic-energy-sdk-privacy-statement-0000001658283582"
                    target="self">https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/whale-hong-kinetic-energy-sdk-privacy-statement-0000001658283582<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>百度联盟广告SDK</td>
              <td>北京百度网讯科技有限公司</td>
              <td>
                设备品牌、型号、软件系统版本、分辨率、网络信号强度、磁盘总空间、系统内存空间、屏幕宽高，屏幕像素密度，系统版本号，设备厂商，设备型号，手机运营商、SIM卡信息、手机重启信息、手机系统更新时间、手机系统创建时间、IDFA、OAID；应用包名、应用签名、应用前后台状态、运行进程信息；操作记录、点击、展示、转化等交互数据；崩溃数据、性能数据
              </td>
              <td>提供广告服务</td>
              <td>
                <a2><a href="https://union.baidu.com/bqt/#/legal/policies" target="self">https://union.baidu.com/bqt/#/legal/policies<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>OPPO广告联盟SDK</td>
              <td>广东欢太科技有限公司</td>
              <td>
                可变设备标识（OAID、DAID），设备信息（机型、品牌），操作系统版本，屏幕分辨率，广告操作记录（用户点击、浏览时间等）；位置信息，传感器信息，软件列表信息，存储空间大小，WiFi信息，设备标识（IMSI、ICCID、Android
                ID、设备SN码）
              </td>
              <td>提供广告服务</td>
              <td>
                <a2><a href="https://u.oppomobile.com/main/privacy.html" target="self">https://u.oppomobile.com/main/privacy.html<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>vivo广告联盟SDK</td>
              <td>广东天宸网络科技有限公司</td>
              <td>设备制造商，设备型号，系统版本，传感器信息；IP地址，联网方式，运营商信息，网络连接状态，
                SSID，BSSID；IMEI，IMSI，OAID，VAID，MAC地址，Android_ID，ICCID，SN号；应用名称，应用包名，应用版本号，软件安装列表；粗略定位信息；广告交互行为；崩溃数据、性能数据；
              </td>
              <td>提供广告服务</td>
              <td>
                <a2><a href="https://adnet.vivo.com.cn/home/faq/18"
                       target="self">https://adnet.vivo.com.cn/home/faq/18<a/></a2>
              </td>
            </tr>
            <tr>
              <td>4399广告联盟SDK</td>
              <td>四三九九网络股份有限公司</td>
              <td>
                设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、手机重启时间和更新时间、sim卡信息、CPU信息、可用存储空间大小；AndroidID、OAID、IMEI、IMSI、MEID；IP地址、运营商信息、WiFi状态、网络信号强度、MAC地址、基站信息；应用包名、运行中的进程信息、版本号、应用前后台状态、运行状态、可疑行为、应用安装信息；传感器信息；广告交互数据；精确位置信息、粗略位置信息；崩溃数据、性能数据
              </td>
              <td>提供广告服务</td>
              <td>
                <a2><a href="https://ptlogin.4399.com/resource/protocol.html?type=2&aids=8" target="self">https://ptlogin.4399.com/resource/protocol.html?type=2&aids=8<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>233乐园广告SDK</td>
              <td>北京龙威互动科技有限公司</td>
              <td>设备/网络/系统信息
                设备制造商、品牌、设备型号、操作系统版本、屏幕分辨率、屏幕方向、屏幕DPI、IP地址、时区、网络类型、运营商、连接的WIFI；OAID、Android_ID、IMEI；宿主应用的包名、版本号、宿主应用的进程名称、运行状态、可疑行为、应用安装列表信息；产品交互数据、广告数据
              </td>
              <td>提供广告服务</td>
              <td>
                <a2><a href="https://dev.233leyuan.com/#/doc/50138"
                       target="self">https://dev.233leyuan.com/#/doc/50138<a/></a2>
              </td>
            </tr>
            <tr>
              <td>TopOn SDK</td>
              <td>广州塔酷信息科技有限公司</td>
              <td>
                系统版本名、系统版本号、当前应用包名、应用版本名、应用版本号、设备生产商、设备型号、分辨率、网络类型、屏幕方向；应用安装来源、传感器信息；android_id、imei、oaid、idfa、idfv、gaid、mac地址、SSID
              </td>
              <td>提供广告服务</td>
              <td>
                <a2><a href="https://docs.toponad.com/#/zh-cn/android/NetworkAccess/SDK_Policy/sdk_policy_access"
                       target="self">https://docs.toponad.com/#/zh-cn/android/NetworkAccess/SDK_Policy/sdk_policy_access<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>Sigmob广告SDK</td>
              <td>北京创智汇聚科技有限公司</td>
              <td>IMEI、GAID、OAID；设备品牌、名称、型号；设备IP、UA、MAC地址、WIFI SSID/BSSID、Android
                ID、IDFA；设备分辨率、宽高、存储空间、设备剩余磁盘大小；手机运营商、网络状态、系统启动时间、电池状态、蓝牙名称；设备语言、时区、国家代码；操作系统版本、系统更新时间；应用名称、应用版本号、应用安装列表；设备传感器信息；地理位置
              </td>
              <td>提供广告服务</td>
              <td>
                <a2><a href="https://www.sigmob.com/policy.html" target="self">https://www.sigmob.com/policy.html<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>AdMob移动广告SDK</td>
              <td>Google Inc.</td>
              <td>IP地址，崩溃日志，与用户相关的性能数据，设备ID，广告数据</td>
              <td>提供广告服务</td>
              <td>
                <a2><a href="https://developers.google.cn/admob/ios/data-disclosure" target="self">https://developers.google.cn/admob/ios/data-disclosure<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>小米PUSH SDK</td>
              <td>北京小米移动软件有限公司</td>
              <td>OAID、Android
                ID、IDFV；应用包名、版本号和运行状态；设备厂商、设备型号、设备内存、操作系统版本、小米推送SDK版本、设备归属地（国家或地区）、SIM卡运营商名称、当前网络类型、WiFi状态；消息创建、送达和点击时间；通知栏设置
              </td>
              <td>提供消息推送服务</td>
              <td>
                <a2><a href="https://dev.mi.com/distribute/doc/details?pId=1534" target="self">https://dev.mi.com/distribute/doc/details?pId=1534<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>vivo消息推送平台SDK</td>
              <td>广东天宸网络科技有限公司</td>
              <td>系统版本号、设备信息（VAID、OAID）、日志信息、WIFI-SSID、ICCID、vaid</td>
              <td>提供消息推送服务</td>
              <td>
                <a2><a href="https://dev.vivo.com.cn/documentCenter/doc/366" target="self">https://dev.vivo.com.cn/documentCenter/doc/366<a/>
                </a2>
              </td>
            </tr>
            <tr>
              <td>OPPO PUSH服务</td>
              <td>广东欢太科技有限公司</td>
              <td>IMEI或OAID，Serial Number，IMSI，User ID，Android ID，Google Advertising ID,
                手机Region设置，设备型号，手机电量，手机操作系统版本及语言；APP包名及版本号，运行状态，推送SDK版本号、网络相关信息，消息发送结果、通知栏状态、锁屏状态
              </td>
              <td>提供消息推送服务</td>
              <td>
                <a2><a href="https://open.oppomobile.com/new/developmentDoc/info?id=10288" target="self">https://open.oppomobile.com/new/developmentDoc/info?id=10288<a/>
                </a2>
              </td>
            </tr>

          </table>

          <br>
          <b>（二）广告类展示</b>
          <br>
          在符合相关法律法规的前提下，我们可能会与第三方广告合作伙伴合作进行广告展示。我们的合作伙伴包含但不限于腾讯等。我们的合作伙伴可能会收集硬件和软件信息，例如<b>IP地址、设备ID和类型，广告ID、设备语言、操作系统、时区以及与Cookie或其他可能唯一标识您设备的技术相关联的标识符</b>。前述合作伙伴收集和处理信息等行为遵守其自身的隐私条款，且不适用于本政策。为保障您的合法权益，如您发现存在风险时，建议您立即终止相关操作并及时与我们取得联系。
          <br>
          <b>（三）Cookies技术及同类技术</b>
          <br>
          为提高您的使用体验，我们会使用Cookies或类似技术（例如：webbeacons,logfiles,scripts,eTags）(以下统称“Cookies”技术)。Cookies技术将在您的设备中生成小文件，以便我们提供特定功能。当您选择关闭Cookies技术后，您可能无法体验我们游戏服务的部分功能。
          <br>
          <br>
          <h2>五、信息的存储</h2>
          （一）我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。<b>如果我们向境外传输，我们将会遵循相关国家规定或者征求您的同意</b>。
          <br>
          （二）我们会通过安全的方式存储您的信息，包括本地存储（例如利用APP进行数据缓存）、数据库和服务器日志。
          <br>
          （三）在您使用公司服务期间，我们会持续保存您的个人信息。如您对账号进行注销或者公司产品停服，我们将从注销或停服之日起保存网络日志【1】年。对于其他数据的保存期限，我们承诺是为了实现提供服务所必须的最短期限，在超出上述期限后，我们会对您的相关信息进行删除或匿名化处理。
          <br>
          <br>
          <h2>六、信息的保护</h2>
          （一）我们努力为用户的信息安全提供保障，以防止信息的泄露、丢失、不当使用、未经授权访问和披露等。我们使用多方位的安全保护措施，以确保用户的个人信息保护处于合理的安全水平，包括身份鉴别、数据加密、访问控制、恶意代码防范、安全审计、技术保护手段、管理制度控制、安全体系保障等诸多方面。
          <br>
          （二）尽管我们采取上述合理有效措施，并遵守相关法律规定要求的标准，但请您理解，由于技术的限制、可能存在的各种恶意手段、我们可控范围外的系统和通讯网络等方面的问题，我们难以始终保证信息百分之百的安全，但我们将尽力确保您提供给我们的个人信息的安全性，我们也建议您在使用产品和服务时充分注意对个人信息的保护，建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息透露给他人。
          <br>
          （三）若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大。安全事件发生后，我们会以公告、推送通知或邮件等形式告知您安全事件的基本情况、我们即将或已经采取的处置措施和补救措施，以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示。
          <br>
          （四）<b>若您一旦离开本游戏及相关服务，浏览或使用其他网站、服务及内容资源，无论您登录、浏览或使用上述软件、网站是否基于本游戏的链接或引导，我们将没有能力和义务保护您对该等软件、网站提交的任何个人信息</b>。
          <br>
          <br>
          <h2>七、您的权利</h2>
          在您使用本游戏和服务期间，我们可能会视游戏产品具体情况为您提供相应的操作设置，以便您可以查询、删除、更正或撤回您的相关个人信息、游戏注册信息、、注销您的账户及撤回您已同意的授权，您可参考本游戏的具体指引进行操作。此外，我们还设置了投诉、请求及举报渠道，您的意见将会得到及时的处理。
          <br>
          具体操作方式为：
          <br>
          1、查询/删除功能：在【联系我们】中获取联系邮箱，向我们发送邮件进行查询和删除；如要清除APP内的数据，用户可在设备的设置->应用->已安装列表中找到本产品，清除数据即可；
          <br>
          2、改变授权范围：通过手机系统权限设置，进行授权范围改变，若有任何需要帮助的，可随时通过邮箱联系我们进行处理；
          <br>
          3、投诉、举报：在【联系我们】中获取联系邮箱，向我们发送邮件对相关行为进行投诉和举报；
          <br>
          4、账户注销：在【联系我们】中获取联系邮箱，向我们发送邮件进行账号注销申请，我们会尽快为您作出解答。
          <br>
          <br>
          <h2>八、未成年人条款</h2>
          （一）<b>若您是未满18周岁的未成年人，在使用本游戏及相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本政策</b>。
          <br>
          （二）我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、储存、共享、转让或披露未成年人的个人信息;如果我们发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，会设法尽快删除相关信息。
          <br>
          （三）若您是未成年人的法定监护人，请您关注您所监护的未成年人是否是在取得您的授权同意之后使用本游戏的服务或提供其个人信息。如果您对您所监护的未成年人的个人信息有疑问，请通过本政策中的联系方式与我们联系。
          <br>
          （四）对于可能涉及的不满14周岁的儿童个人信息，我们除遵守本政策关于用户个人信息的约定外，还会严格遵循《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露。
          <br>
          <br>
          <h2>九、政策变更</h2>
          （一）我们会适时对本政策进行修订、补充或变更，这些修订、补充或变更构成本政策的一部分并具有等同于本政策的效力。未经您明确同意，我们不会削减您依据当前生效的本政策所应享受的权利。
          <br>
          （二）本政策更新前，我们会通过游戏页面显著位置提示或向您发送电子邮件等适当方式通知您，以便您及时了解本政策的最新版本。再次征得您的明示同意后，我们将按照更新后的隐私政策收集、处理或使用您的个人信息。
          <br>
          <br>
          <h2>十、联系我们</h2>
          我们设有个人信息保护专职部门并指定了专门的儿童个人信息保护负责人，将严格按照本规则保护儿童个人信息。如监护人和儿童有关于网络信息安全的投诉和举报，或对本规则、儿童个人信息保护规则、措施的相关事宜有任何问题、意见或建议，您可以发送邮件与我们联系，我们将在收到问题、意见或建议，并验证监护人和/或儿童身份后的十五个工作日内予以回复。
          <br>
          <br>
          <b>联系邮箱：</b>zhuoxunhudong-kf@qq.com
          <br>
          <b>联系地址：</b>广州市天河区珠江东路30号601房
          <br>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "privacyNt",
  components: {},
  mounted() {
    window.scrollTo(0, 0);
  },
  created() {

  }
}
</script>

<style scoped>
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin: 0;
}
</style>
<style scoped>
body {
  padding: 20px 20px 20px 20px;
  text-align: left;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  font-size: 1.2rem;
  line-height: 2.2rem;
}

h1 {
  text-align: center;
  font-size: 2rem;
  line-height: 3rem;
}

h2 {
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 2.4rem;
}

b {
  font-weight: bold;
  line-height: 2.2rem;
}

table {
  text-align: left;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  font-size: 1.2rem;
  line-height: 2.2rem;;
  border: 1px solid #909399;
  border-collapse: collapse;
}

tr th {
  font-weight: bold;
  background-color: #F7F8FA;
  padding: 6px;
}

tr td {
  padding: 6px;
}

a {
  color: #0000ff;
}

a2 {
  display: block;
  width: 160px;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/privacy_nt.vue